module.exports = __webpack_public_path__ + "static/img/banber (5).be6d6ce0.png";